import { useId } from "react";

import { motion } from "motion/react";

import { cn } from "@/lib/utils";

interface SegmentedProps<T extends string> {
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  label: string;
  /** Butun kenglik — uzun yorliqlar teng ulushda, kerak bo'lsa ikki qatorda. */
  block?: boolean;
}

/** Kichik tanlov: 2–4 variant uchun Select'dan tezroq; faol belgi suzib o'tadi. */
export function Segmented<T extends string>({
  value,
  options,
  onChange,
  label,
  block = false,
}: SegmentedProps<T>) {
  const id = useId();
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn(
        "bg-card rounded-2xl border p-1 shadow-xs",
        block ? "grid w-full auto-cols-fr grid-flow-col" : "inline-flex",
      )}
    >
      {options.map(option => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(option.value)}
            className={cn(
              "relative min-h-8 rounded-xl px-3.5 py-1 text-sm leading-tight font-medium transition-colors",
              active ? "text-primary-foreground" : "text-muted-foreground hover:text-foreground",
            )}
          >
            {active ? (
              <motion.span
                layoutId={`segmented-${id}`}
                className="bg-primary shadow-primary/25 absolute inset-0 rounded-xl shadow-sm"
                transition={{ type: "spring", stiffness: 420, damping: 32 }}
              />
            ) : null}
            <span className="relative">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
